import { render } from "./PlayIconComponent.vue?vue&type=template&id=37a5c77e"
const script = {}

import exportComponent from "/home/csoetaert/projects/adct-client-companion/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__